import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Grid, TextField, Box, Typography } from "@material-ui/core";
import { HourlyDataContext } from "../../Contexts/HourlyDataContext";
import { makeStyles } from "@material-ui/core/styles";
import HourlyActionMenu from "./HourlyActionMenu";

const useStyles = makeStyles((theme) => ({
  flexContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  flexGrow: {
    flexGrow: 1,
  },
  paddingLeft: {
    marginLeft: theme.spacing(2),
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "4fr 4fr 1fr",
    gridGap: theme.spacing(1),
  },
}));

const HourlyItem = ({
  itemData,
  truckId,
  week,
  day,
  itemId,
  conNoteList,
  ...otherProps
}) => {
  const { createHourlyModel, comments } = useContext(HourlyDataContext);
  const hourlyModel = createHourlyModel({ week, day });
  const fetchedColumns = [
    "startTimeString",
    "endTimeString",
    "hourlyRate",
    "changedRateCons",
  ];
  const calculatedColumns = ["totalHours", "totalCharge"];
  const classes = useStyles();

  const fetchedObj = fetchedColumns.reduce((acc, col) => {
    acc[col] = hourlyModel[col].getValueFromRequest(itemData[col]);
    return acc;
    // return { ...acc, [col]: hourlyModel[col].getValueFromRequest(data[col]) };
  }, {});

  const calculatedObj = calculatedColumns.reduce((acc, col) => {
    acc[col] = hourlyModel[col].calculateValue(fetchedObj);
    return acc;
  }, {});

  const displayObj = {
    ...itemData,
    ...fetchedObj,
    ...calculatedObj,
  };

  return (
    <Box className={classes.flexContainer}>
      <Grid container spacing={1}>
        {["startTimeString", "endTimeString", "totalHours"].map((col) => (
          <Grid item key={col} xs={3}>
            <TextField
              disabled
              fullWidth
              value={hourlyModel[col].displayValue(displayObj)}
              label={hourlyModel[col].displayName}
              // {...hourlyModel[col].textFieldProps}
            />
          </Grid>
        ))}

        <Grid item xs={3} className={classes.flexContainer}>
          <Typography>{hourlyModel.approvalState.displayName}: </Typography>
          <Typography>
            {" "}
            {hourlyModel.approvalState.displayValue(displayObj)}
          </Typography>
        </Grid>

        {["hourlyRate", "totalCharge"].map((col) => (
          <Grid item key={col} xs={3}>
            <TextField
              disabled
              fullWidth
              value={hourlyModel[col].displayValue(displayObj)}
              label={hourlyModel[col].displayName}
              // {...hourlyModel[col].textFieldProps}
            />
          </Grid>
        ))}
        {["changedRateCons"].map((col) => (
          <Grid item key={col} xs={3}>
            <TextField
              disabled
              fullWidth
              value={hourlyModel[col].displayValue(displayObj)}
              label={hourlyModel[col].displayName}
              {...hourlyModel[col].textFieldProps}
            />
          </Grid>
        ))}

        <Grid item xs={3} className={classes.flexContainer}>
          {/* <Typography>Actions:</Typography> */}
          <HourlyActionMenu
            truckId={truckId}
            itemData={itemData}
            week={week}
            day={day}
            itemId={itemId}
            className={classes.paddingLeft}
            conNoteList={conNoteList}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HourlyItem;

HourlyItem.propTypes = {
  itemData: PropTypes.shape({
    startTimeString: PropTypes.string.isRequired,
    endTimeString: PropTypes.string.isRequired,
    hourlyRate: PropTypes.number.isRequired,
    changedRateCons: PropTypes.array.isRequired,
  }).isRequired,
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
};

/*




      <Grid item>
        <TextField
          disabled
          value={startTime.split("T")[1]}
          {...dpcColumns.startTime.textFieldProps}
          label={dpcColumns.startTime.displayName}
        />
      </Grid>
      <Grid item>
        <TextField
          disabled
          value={endTime.split("T")[1]}
          {...dpcColumns.endTime.textFieldProps}
          label={dpcColumns.endTime.displayName}
        />
      </Grid>
      <Grid item>
        <TextField disabled name="totalHours" value={hoursDiff()} label="Total Hours" />
      </Grid>
      <Grid item>
        <TextField
          disabled
          value={hourlyRate}
          {...dpcColumns.hourlyRate.textFieldProps}
          label={dpcColumns.hourlyRate.displayName}
        />
      </Grid>
      <Grid item>
        <TextField
          disabled
          value={totalCharge}
          {...dpcColumns.totalCharge.textFieldProps}
          label={dpcColumns.totalCharge.displayName}
        />
      </Grid>
      <Grid item>
        <TextField
          disabled
          value={changedRateCons.join("\r\n\r")}
          {...dpcColumns.changedRateCons.textFieldProps}
          label={dpcColumns.changedRateCons.displayName}
        />
      </Grid>
      <Grid item>
        <ApproveRejectLinehaulHourly
          dataType="hourly"
          truckId={truckId}
          itemData={data}
          week={week}
          day={day}
          itemId={itemId}
        />
      </Grid>



*/
